import React, { useEffect, useState } from 'react'
import Container from 'react-bootstrap/Container'

import './index.css'

import AresNavBar from './../../Layout/NavBar/NavBar';

import ConfirmMail from './steps/ConfirmMail'
import CreditCard from './steps/CreditCard'
import AddressForm from './steps/Address'

export default function CompleteRegister({ history, location }) {
    const [activeStep, setActiveStep] = useState(1)

    const steps = [
        { id: 1, name: 'Confirmar email', component: <ConfirmMail /> },
        { id: 2, name: 'Endereço', component: <AddressForm /> },
        { id: 3, name: 'Pagamento', component: <CreditCard /> },
    ];

    useEffect(() => {
        console.log('iniciou  a pagina de registro')
    }, [])

    return (
        <>
            <AresNavBar />
            <div className="CompleteRegister">
                <Container>
                    {renderHeader()}
                    {renderBody()}
                </Container>
            </div>
        </>
    )

    function renderHeader() {
        return (
            <div className="header">
                {steps.map((step) => (
                    <div className={step.id === activeStep ? "step-item active" : 'step-item'} >
                        <span className="step-number">{step.id}</span>
                        <span className="step-name">{step.name}</span>
                    </div>
                ))}
            </div>
        )
    }


    function renderBody() {
        return steps.map((step) => (
            (step.id === activeStep ? renderStepComponent(step.component) : null)
        ));
    }

    function renderStepComponent(component) {
        return component
    }
}